import { BuildingInfo } from '@models/BuildingInfo'
import { BillingCategoryCode } from '@models/Receipt'
import { IS_STNET } from '@utils/Constants'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * search
 */

export type SearchParams = {
  buildingName: string
  roomName: string
}

type SearchResponseData = {
  buildingId: number
  roomId: number
  isDormitory: boolean
  isIssuingCommission: boolean
  issuingCommissionPrice: number
  paymentMethods: (typeof BillingCategoryCode.CreditCard | typeof BillingCategoryCode.AccountTransfer)[]
}

export const search = async (params: SearchParams) => {
  return await get<SearchResponseData>('/v1/buildings/search', { ...params, isSTNet: IS_STNET }, false)
}

/**
 * searchBuildings
 */

export type SearchBuildingsResponseData = {
  buildings: BuildingInfo[]
}

export const searchBuildings = async (keyword: string) => {
  return await get<SearchBuildingsResponseData>(
    '/v1/buildings/searchForWA',
    {
      key: 'postalCode',
      keyword,
      isSTNet: IS_STNET,
    },
    false,
  )
}
